import c from "config";
import {
  DELETE_USER,
  DELETE_USER_FAILED,
  DELETE_USER_SUCCESS,
  EDIT_USER,
  EDIT_USER_FAILED,
  EDIT_USER_SUCCESS,
  FETCH_ALL_ADMINS_FAILED,
  FETCH_ALL_ADMINS_START,
  FETCH_ALL_ADMINS_SUCCESS,
  FETCH_ALL_DOCTORS,
  FETCH_ALL_DOCTORS_FAILED,
  FETCH_ALL_DOCTORS_SUCCESS,
  FETCH_ALL_USERS,
  FETCH_ALL_USERS_FAILED,
  FETCH_ALL_USERS_SUCCESS,
  FETCH_BROKER,
  FETCH_BROKER_FAILED,
  FETCH_BROKER_SUCCESS,
  SAVE_USERS_DEVICE_INFO_FAILED,
  SAVE_USERS_DEVICE_INFO_START,
  UPDATE_USER_PROFILE,
  USER_SIGNUP_START,
  USER_SIGNUP_FAILED,
  USER_SIGNUP_SUCCESS,
  CLEAR_USER_ERROR
} from "../store/types";
import { store } from "../store/store";


export const fetchUsers = () => (dispatch) => (firebase) => {
  const { usersRef } = firebase;

  dispatch({
    type: FETCH_ALL_USERS,
    payload: null,
  });
  usersRef.on("value", (snapshot) => {
    if (snapshot.val()) {
      const data = snapshot.val();

      const arr = Object.keys(data)
        .filter((i) => data[i].userType != "admin")
        .map((i) => {
          data[i].id = i;
          return data[i];
        });
      dispatch({
        type: FETCH_ALL_USERS_SUCCESS,
        payload: arr,
      });
    } else {
      dispatch({
        type: FETCH_ALL_USERS_FAILED,
        payload: "No users available.",
      });
    }
  });
};

export const fetchBrokers = () => (dispatch) => (firebase) => {
  const { usersRef } = firebase;

  dispatch({
    type: FETCH_ALL_DOCTORS,
    payload: null,
  });

  usersRef
    .orderByChild("userType")
    .equalTo("broker")
    .once("value", (snapshot) => {
      if (snapshot.val()) {
        const data = snapshot.val();
        const arr = Object.keys(data).map((i) => {
          data[i].id = i;
          return data[i];
        });
        dispatch({
          type: FETCH_ALL_DOCTORS_SUCCESS,
          payload: arr,
        });
      } else {
        dispatch({
          type: FETCH_ALL_DOCTORS_FAILED,
          payload: "No Docs available.",
        });
      }
    });

  usersRef
    .orderByChild("userType")
    .equalTo("broker")
    .once("value", (snapshot) => {
      if (snapshot.val()) {
        const data = snapshot.val();
        const arr = Object.keys(data).map((i) => {
          data[i].id = i;
          return data[i];
        });
        dispatch({
          type: FETCH_ALL_DOCTORS_SUCCESS,
          payload: arr,
        });
      } else {
        dispatch({
          type: FETCH_ALL_DOCTORS_FAILED,
          payload: "No Docs available.",
        });
      }
    });
};

export const fetchAdmins = () => (dispatch) => (firebase) => {
  const { usersRef } = firebase;

  dispatch({
    type: FETCH_ALL_ADMINS_START,
    payload: null,
  });

  usersRef
    .orderByChild("userType")
    .equalTo("admin")
    .once("value", (snapshot) => {
      if (snapshot.val()) {
        const data = snapshot.val();
        const arr = Object.keys(data).map((i) => {
          data[i].id = i;
          return data[i];
        });
        dispatch({
          type: FETCH_ALL_ADMINS_SUCCESS,
          payload: arr,
        });
      } else {
        dispatch({
          type: FETCH_ALL_ADMINS_FAILED,
          payload: "No Admins available.",
        });
      }
    });
};

export const SaveUsersDeviceInfo =
  (NewPushtoken, previousdeviceinfo, currentdeviceinfo) => (dispatch) => (firebase) => {
    try {
      const { UserDeviceInfoRef, auth } = firebase;
      dispatch({
        type: SAVE_USERS_DEVICE_INFO_START,
        payload: null,
      });

      if (previousdeviceinfo?.expopushtoken !== NewPushtoken) {
        dispatch({
          type: SAVE_USERS_DEVICE_INFO_START,
          payload: null,
        });
        if (currentdeviceinfo.brand !== "HUAWEI") {
          let devicemodelid;
          let brand = currentdeviceinfo.brand;
          let model = currentdeviceinfo.modelName;
          let deviceproductname = currentdeviceinfo.productName;
          let devicedesignname = currentdeviceinfo.designName;
          if (currentdeviceinfo.modelId) {
            devicemodelid = currentdeviceinfo.modelId;
          } else {
            devicemodelid = currentdeviceinfo.osName;
          }
          let deviceOSname = currentdeviceinfo.osName;
          let deviceOSversion = currentdeviceinfo.osVersion;
          let deviceName = currentdeviceinfo.deviceName;

          let payload = {
            Brand: brand,
            Model: model,
            deviceproductname,
            devicedesignname,
            devicemodelid,
            deviceOSname,
            deviceOSversion,
            deviceName,
            expopushtoken: NewPushtoken,
          };

          console.log("payload", payload);

          if (payload) {
            UserDeviceInfoRef(auth.currentUser.uid).set(payload);
          }

          if (payload) {
            UserDeviceInfoRef(auth.currentUser.uid).set(payload);
          }
        }
      }
    } catch (error) {
      console.log("error", error);
      dispatch({
        type: SAVE_USERS_DEVICE_INFO_FAILED,
        payload: error,
      });
    }
  };

export const addUser = (userdata) => (dispatch) => (firebase) => {
  const { usersRef } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: userdata,
  });

  usersRef
    .push(userdata)
    .then(() => {
      dispatch({
        type: EDIT_USER_SUCCESS,
        payload: null,
      });
    })
    .catch((error) => {
      dispatch({
        type: EDIT_USER_FAILED,
        payload: error,
      });
    });
};

export const editUser = (id, user) => (dispatch) => (firebase) => {
  const { singleUserRef } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: user,
  });
  let editedUser = user;
  delete editedUser.id;
  singleUserRef(id)
    .update(editedUser)
    //.set(editedUser)
    .then(() => {
      dispatch({
        type: EDIT_USER_SUCCESS,
        payload: null,
      });
    })
    .catch((error) => {
      dispatch({
        type: EDIT_USER_FAILED,
        payload: error,
      });
    });
};

export const clearUserErrors = () => (dispatch) => (firebase) => {
  dispatch({
    type: CLEAR_USER_ERROR,
    payload: null,
  });
};

export const editUserSharedBrokers = (id, users) => (dispatch) => (firebase) => {
  const { singleUserSharedBrokersRef, singleUserRef } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: null,
  });

  try {
    let editedUsers = users;
    console.log("editedUsers", editedUsers)
    singleUserSharedBrokersRef(id)
      .set(editedUsers).then(() => {
        singleUserRef(id).on("value", (snapshot) => {
          dispatch({
            type: EDIT_USER_SUCCESS,
            payload: snapshot.val(),
          });
        })
      })

  } catch (error) {
    console.log("error, ", error)
    dispatch({
      type: EDIT_USER_FAILED,
      payload: error,
    });
  }
};

export const deleteUser = (id) => (dispatch) => (firebase) => {
  const { singleUserRef } = firebase;

  dispatch({
    type: DELETE_USER,
    payload: id,
  });

  singleUserRef(id)
    .remove()
    .then(() => {
      dispatch({
        type: DELETE_USER_SUCCESS,
        payload: null,
      });
    })
    .catch((error) => {
      dispatch({
        type: DELETE_USER_FAILED,
        payload: error,
      });
    });
};
export const fetchBroker = (id) => (dispatch) => (firebase) => {
  const { singleUserRef } = firebase;

  dispatch({
    type: FETCH_BROKER,
    payload: null,
  });
  try {
    singleUserRef(id).on("value", (snapshot) => {
      if (snapshot.val()) {
        const data = snapshot.val();
        dispatch({
          type: FETCH_BROKER_SUCCESS,
          payload: data,
        });
      } else {
        dispatch({
          type: FETCH_BROKER_FAILED,
          payload: "Error Fetching the user",
        });
      }
    });
  } catch (error) {
    console.log("error", error);
    dispatch({
      type: FETCH_BROKER_FAILED,
      payload: error,
    });
  }
};


// helper method
const validateBrokerData = (data) => {
  const requiredFields = [
    // "firstname",
    // "lastname",
    // "agencyId",
    // "cityId",
    // "mobileNumber",
    // "emailAddress",
    // "workNumber",
    // "qualification",
    // "fidelityFundCertificationYear",
    // "fidelityFundCertificationNumber",
    // "idNumber",
    // "incomeTaxNumber",
    // "countryId",
  ];

  const missingFields = requiredFields.filter(
    (field) => !data[field] || data[field].toString().trim() === ""
  );

  return {
    isValid: missingFields.length === 0,
    missingFields,
  };
};

const updateWebProfileImage =
  (uid, imageFile) => (dispatch) => (firebase) => {
    const { singleUserRef, profileImageRef } = firebase;
    console.log("imageFile", imageFile);
    console.log("uid", uid);

    console.log("profileImageRef:", profileImageRef(uid));
    profileImageRef(uid)
      .put(imageFile)
      .then(() => {
        return profileImageRef(uid).getDownloadURL();
      })
      .then((url) => {
        // let profile = userAuthData.profile;
        // profile.profile_image = url;
        singleUserRef(uid).update({
          profile_image: url,
        });
        // dispatch({
        //   type: UPDATE_USER_PROFILE,
        //   payload: profile,
        // });
      });
  };

export const addBrokerHomeOffice =
  (userId, data) => () => (firebase) => {
    const { brokerHomeOfficeRef, singleUserRef } = firebase;

    singleUserRef(userId)
      .update(data)
  };

export const editBrokerApproval =
  (data) => (dispatch) => (firebase) => {
    const { brokerHomeOfficeRef, singleUserRef } = firebase;

    dispatch({
      type: EDIT_USER,
      payload: data,
    });
    let updateData = {
      ...data,
      approved: data?.approved === true ? false : true
    }
    try {
      singleUserRef(data.id)
        .update(updateData)
      dispatch({
        type: EDIT_USER_SUCCESS,
        payload: null,
      })
    } catch (error) {
      dispatch({
        type: EDIT_USER_FAILED,
        payload: error,
      });
    }
  };

export const AddBroker = (data) => (dispatch) => async (firebase) => {
  const { auth, api, singleUserRef, profileImageRef } = firebase;

  dispatch({
    type: USER_SIGNUP_START,
    payload: null,
  });

  const { isValid, missingFields } = validateBrokerData(data);

  if (!isValid) {
    alert("Missing required fields:", missingFields);
    dispatch({
      type: USER_SIGNUP_FAILED,
      payload: error,
    });
    return; // stop here if invalid
  }
  const token = store.getState().tokenManagementReducer?.token?.token;
  // const updateProfileImage = async (userid) => {
  //   if (!data.profilePicture || !data.profilePicture.base64) return;

  //   const profilePicture = {
  //     bytes: data.profilePicture.base64,
  //     mimeContentType: data.profilePicture.mimeContentType,
  //     caption: data.profilePicture.caption,
  //   };

  //   // Convert base64 to Blob
  //   const byteCharacters = atob(profilePicture.bytes);
  //   const byteNumbers = new Array(byteCharacters.length);
  //   for (let i = 0; i < byteCharacters.length; i++) {
  //     byteNumbers[i] = byteCharacters.charCodeAt(i);
  //   }
  //   const byteArray = new Uint8Array(byteNumbers);
  //   const imageBlob = new Blob([byteArray], { type: profilePicture.mimeContentType });

  //   // Upload to Firebase Storage
  //   return profileImageRef(userid)
  //     .put(imageBlob)
  //     .then(() => profileImageRef(userid).getDownloadURL())
  //     .then((url) => {
  //       const profile = {
  //         ...userAuthData.profile,
  //         profile_image: url,
  //       };
  //       singleUserRef(userid).update({
  //         profile_image: url,
  //       });
  //       dispatch({
  //         type: UPDATE_USER_PROFILE,
  //         payload: profile,
  //       });
  //     })
  //     .catch((error) => {
  //       console.error("Error uploading profile image:", error);
  //     });
  // };

  const username = data.firstname.toLowerCase() + data.lastname.toLowerCase();
  let createDate = new Date();
  console.log("token in pp agent action", token);
  const firebaseObject = {
    agencyId: data?.agencyId,
    createdAt: createDate,
    firstName: data.firstname,
    lastName: data.lastname,
    mobile: data.workNumber,
    email: data.emailAddress,
    password: data.password,
    identityNumber: data.idNumber,
    userType: data.Firebaseusertype,
    brokerHomeOffice: data?.brokerHomeOffice,
    username: username,
  };

  // const firebaseObject =data;
  const property24Object = data;
  const websiteObject = data;

  try {
    const signUpResult = await api.emailSignUp(firebaseObject);

    console.log(`Sign up result: ${JSON.stringify(signUpResult)}`)

    if (signUpResult.uid) {
      const userid = signUpResult.uid;

      if (data.file) {
        await dispatch(updateWebProfileImage(userid, data.file))(firebase);
      }

      if (data.brokerHomeOffice) {
        await dispatch(addBrokerHomeOffice(userid, data))(firebase);
      }

      try {
        await dispatch(api.addAgentP24(property24Object, userid));
        await dispatch(api.addWebsite(websiteObject, userid));
        await dispatch(api.addPpAgent(property24Object, userid, token));
      } catch (error) {
        console.error("Error in addAgentP24 or addWebsite:", error);
      }
      await dispatch(api.fetchUsers());

      alert("Broker created successfully");

      dispatch({
        type: USER_SIGNUP_SUCCESS,
        payload: data,
      });
    }

    if (signUpResult?.error?.message !== undefined) {
      alert(`Sign up error: ${signUpResult.error.message}`);
      dispatch({
        type: USER_SIGNUP_FAILED,
        payload: signUpResult.error.message,
      });
    }


  } catch (err) {
    dispatch({
      type: USER_SIGNUP_FAILED,
      payload: err,
    });
    console.error("emailSignUp error:", err);
  }
};

export const AddP24 = (data, userid) => (dispatch) => async (firebase) => {
  const { auth, api } = firebase;
  const { isValid, missingFields } = validateBrokerData(data);

  if (!isValid) {
    console.error("Missing required fields:", missingFields);
    return; // stop here if invalid
  }
  const property24Object = data;
  await dispatch(api.addAgentP24(property24Object, userid));
};
export const AddWebsite = (data, userid) => (dispatch) => async (firebase) => {
  const { auth, api } = firebase;


  const { isValid, missingFields } = validateBrokerData(data);

  if (!isValid) {
    console.error("Missing required fields:", missingFields);
    return; // stop here if invalid
  }
  const websiteObject = data;
  await dispatch(api.addWebsite(websiteObject, userid));



};

export const EditBroker = (data, userid) => (dispatch) => async (firebase) => {
  const { auth, api } = firebase;
  const object = data;
  // console.log("object",object);
  // console.log("userid",userid);
  // console.log("agentId :",object.agentId);


  const firebaseObject = {
    ...data,
    firstName: data.firstname,
    lastName: data.lastname,
    mobile: data.workNumber,
    email: data.emailAddress,
    password: data.password,
    identityNumber: data.idNumber,
    userType: data.Firebaseusertype,
    username: data.username,
  };
  try {
    if (userid) {
      await dispatch(api.editUser(userid, firebaseObject));
      await dispatch(api.fetchUsers());
      console.log("data.file", data.file);

      if (object.agentId) {
        console.log("edit p24agent");

        await dispatch(api.UpdateAgentP24(object, userid));
      }

      if (data.file) {
        await dispatch(updateWebProfileImage(userid, data.file))(firebase);
      }


      if (data.websiteID) {
        await dispatch(api.addWebsite(data, userid));
      }


    }
  } catch (err) {
    console.error('emailSignUp error:', err);
  }

};